import {Component} from '@angular/core';
import {NzDropDownModule} from 'ng-zorro-antd/dropdown';
import {NzIconModule} from 'ng-zorro-antd/icon';
import {NzTooltipModule} from 'ng-zorro-antd/tooltip';
import {TranslatePipe} from '@ngx-translate/core';
import {LanguageService, WebLanguage} from '../../services/language.service';

@Component({
  selector: 'app-language-switcher',
  templateUrl: './language-switcher.component.html',
  imports: [NzDropDownModule, NzIconModule, NzTooltipModule, TranslatePipe]
})
export class LanguageSwitcherComponent {

  public readonly languages = Object.entries(this.languageService.languages)
    .map(([code, config]) => ({code: code as WebLanguage, label: config.label}));

  constructor(public languageService: LanguageService) {
  }

  // neu laden, damit auch einmal berechnete Texte (Kalender, Datumsformate, Listen aus dem Code) die neue Sprache haben
  public async select(language: WebLanguage): Promise<void> {
    if (language === this.languageService.currentLanguage) {
      return;
    }
    await this.languageService.setLanguage(language);
    window.location.reload();
  }
}
